var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaricon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.42 5.51C19.22 4.92 18.66 4.5 18 4.5H7C6.34 4.5 5.79 4.92 5.58 5.51L3.5 11.5V19C3.5 19.83 4.17 20.5 5 20.5C5.83 20.5 6.5 19.83 6.5 19V18.5H18.5V19C18.5 19.82 19.17 20.5 20 20.5C20.82 20.5 21.5 19.83 21.5 19V11.5L19.42 5.51ZM8 15.5C7.17 15.5 6.5 14.83 6.5 14C6.5 13.17 7.17 12.5 8 12.5C8.83 12.5 9.5 13.17 9.5 14C9.5 14.83 8.83 15.5 8 15.5ZM17 15.5C16.17 15.5 15.5 14.83 15.5 14C15.5 13.17 16.17 12.5 17 12.5C17.83 12.5 18.5 13.17 18.5 14C18.5 14.83 17.83 15.5 17 15.5ZM6.31 9.5L7.35 6.5H17.64L18.68 9.5H6.31Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaricon);
export default __webpack_public_path__ + "static/media/caricon.960f5b51.svg";
export { ForwardRef as ReactComponent };